var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8335 2.19434H4.16683C3.01624 2.19434 2.0835 3.12708 2.0835 4.27767V8.44434C2.0835 9.59493 3.01624 10.5277 4.16683 10.5277H20.8335C21.9841 10.5277 22.9168 9.59493 22.9168 8.44434V4.27767C22.9168 3.12708 21.9841 2.19434 20.8335 2.19434Z",
    fill: "#DCA11C",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8335 14.6943H4.16683C3.01624 14.6943 2.0835 15.6271 2.0835 16.7777V20.9443C2.0835 22.0949 3.01624 23.0277 4.16683 23.0277H20.8335C21.9841 23.0277 22.9168 22.0949 22.9168 20.9443V16.7777C22.9168 15.6271 21.9841 14.6943 20.8335 14.6943Z",
    fill: "#DCA11C",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 6.36133H6.26",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 18.8613H6.26",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSection);
export default __webpack_public_path__ + "static/media/section.c6de5c64eeabcc176d4a070635965446.svg";
export { ForwardRef as ReactComponent };